import useViewModel from '../ViewModel'
import HeaderSection from './HeaderSection'
import ItemsTableSection from './ItemsTableSection'
import ProductPileSection from './ProductPileSection'
import DeliverySiteSection from './DeliverySiteSection'
import FinanceSection from './FinanceSection'
import DeliveryAgreementSection from './DeliveryAgreementSection'
import NoticeTypeSegment from './NoticeTypeSegment'
import WorkOpeningNoticeInstallationForm from './Installation/WorkOpeningNoticeInstallationForm'

type ViewModelReturn = ReturnType<typeof useViewModel>

interface Props {
  vm: ViewModelReturn
}

const WorkOpeningNoticeForm: React.FC<Props> = ({ vm }) => {
  return (
    <>
      <NoticeTypeSegment
        noticeType={vm.noticeType}
        onChange={vm.setNoticeType}
      />

      <div className='col-12 text-center mb-2'>
        <h3 className='fw-bolder text-gray-900 mb-0'>{vm.noticeTitle}</h3>
      </div>

      {vm.noticeType === 'shipping' ? (
        <>
      <HeaderSection
        isView={vm.isView}
        headerDoc={vm.headerDoc}
        updateHeaderDoc={vm.updateHeaderDoc}
        sendTo={vm.sendTo}
        setSendTo={vm.setSendTo}
      />

      <ItemsTableSection
        isView={vm.isView}
        items={vm.items}
        addItemRow={vm.addItemRow}
        removeItemRow={vm.removeItemRow}
        updateItemRow={vm.updateItemRow}
      />

      <ProductPileSection
        isView={vm.isView}
        selectedPileSize={vm.selectedPileSize}
        setSelectedPileSize={vm.setSelectedPileSize}
      />

      <DeliverySiteSection
        isView={vm.isView}
        deliverySite={vm.deliverySite}
        updateDeliverySite={vm.updateDeliverySite}
      />

      <FinanceSection isView={vm.isView} payment={vm.payment} updatePayment={vm.updatePayment} />

      <DeliveryAgreementSection
        isView={vm.isView}
        deliveryNotes={vm.deliveryNotes}
        setDeliveryNotes={vm.setDeliveryNotes}
      />
        </>
      ) : (
        <WorkOpeningNoticeInstallationForm vm={vm} />
      )}
    </>
  )
}

export default WorkOpeningNoticeForm
